import type { QSsrContext } from '#q-app'
import type { LeadCreate } from 'src/types/Lead'
import { getApiInstances } from 'src/utils/apiManager'

export function useLeadService(ssrContext?: QSsrContext | null) {
  const api = getApiInstances(ssrContext).programmes
  return {
    async saveLead(data: LeadCreate): Promise<void> {
      await api.post('/leads', data)
    },
  }
}
